<template>
  <b-modal
    id="modal-dispute"
    ref="modal"
    title="Mark Invoice as Disputed"
    ok-title="Confirm Dispute"
    ok-variant="danger"
    @ok="handleOk"
    @hidden="reset"
  >
    <b-form>
      <b-form-group label="Invoice">
        <b-form-input :value="form.invoice_number" readonly />
      </b-form-group>
      <b-form-group label="Dispute Reason *">
        <b-form-select v-model="form.reason" :options="reasonSelectOptions" />
      </b-form-group>
      <b-form-group label="Details / Notes *">
        <b-form-textarea v-model="form.notes" rows="4" placeholder="Describe the dispute (rate mismatch, service issue, wrong GSTIN, …)" />
      </b-form-group>
      <b-form-group label="Expected Resolution Date">
        <b-form-input v-model="form.resolution_date" type="date" />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'DisputeModal',
  components: { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea },
  data() {
    return {
      form: { invoice_id: null, invoice_number: '', reason: null, notes: '', resolution_date: null },
      reasonOptions: [
        'Rate Mismatch', 'Wrong GSTIN', 'Service Not Rendered', 'Duplicate Invoice',
        'PO/WO Not Matching', 'GST Discrepancy', 'Candidate Attrition Clawback', 'Other'
      ]
    }
  },
  computed: {
    reasonSelectOptions() {
      return [
        { value: null, text: 'Select reason' },
        ...this.reasonOptions.map(r => ({ value: r, text: r }))
      ]
    }
  },
  methods: {
    show(invoice) {
      this.form = {
        invoice_id: invoice.invoice_id || invoice.invoice_number || invoice.id,
        invoice_number: invoice.invoice_id || invoice.invoice_number || '',
        reason: null, notes: '', resolution_date: null
      }
      this.$nextTick(() => this.$refs.modal && this.$refs.modal.show())
    },
    hide() { this.$refs.modal && this.$refs.modal.hide() },
    handleOk(bvEvt) {
      bvEvt.preventDefault()
      if (!this.form.reason || !this.form.notes) {
        this.$bvToast.toast('Dispute Reason and Details are required.', { title: 'Validation', variant: 'warning', solid: true })
        return
      }
      this.$emit('save', { ...this.form })
    },
    reset() {
      this.form = { invoice_id: null, invoice_number: '', reason: null, notes: '', resolution_date: null }
    }
  }
}
</script>
